export const Events = Object.freeze({
  VARIANT_SELECTED: 'scale:variant:selected',
  MEDIA_PREVIEW: 'scale:media:preview',
  MODAL_OPEN: 'scale:modal:open',
  MODAL_CLOSE: 'scale:modal:close',
  DRAWER_OPEN: 'scale:drawer:open',
  DRAWER_CLOSE: 'scale:drawer:close',
  TOAST: 'scale:toast',
  QUANTITY_BREAKS_UPDATED: 'scale:quantity-breaks:updated',
  BUNDLE_UPDATED: 'scale:bundle:updated',
  SUBSCRIPTION_UPDATED: 'scale:subscription:updated',
  FILTERS_UPDATED: 'scale:filters:updated',
  FILTERS_FAILED: 'scale:filters:failed',
});

export class VariantSelectedEvent extends Event {
  constructor(variant, productId) {
    super(Events.VARIANT_SELECTED, { bubbles: true });
    this.variant = variant;
    this.productId = productId;
  }
}

export class MediaPreviewEvent extends Event {
  constructor(mediaId, productId) {
    super(Events.MEDIA_PREVIEW, { bubbles: true });
    this.mediaId = mediaId;
    this.productId = productId;
  }
}

export class ModalOpenEvent extends Event {
  constructor(id) {
    super(Events.MODAL_OPEN, { bubbles: true });
    this.modalId = id;
  }
}

export class ModalCloseEvent extends Event {
  constructor(id) {
    super(Events.MODAL_CLOSE, { bubbles: true });
    this.modalId = id;
  }
}

export class DrawerOpenEvent extends Event {
  constructor(id) {
    super(Events.DRAWER_OPEN, { bubbles: true });
    this.drawerId = id;
  }
}

export class DrawerCloseEvent extends Event {
  constructor(id) {
    super(Events.DRAWER_CLOSE, { bubbles: true });
    this.drawerId = id;
  }
}

export class ToastEvent extends Event {
  constructor(message, { type = 'info', duration = 4000 } = {}) {
    super(Events.TOAST, { bubbles: true });
    this.message = message;
    this.toastType = type;
    this.duration = duration;
  }
}

export class QuantityBreaksUpdatedEvent extends Event {
  constructor(variantId, breaks) {
    super(Events.QUANTITY_BREAKS_UPDATED, { bubbles: true });
    this.variantId = variantId;
    this.breaks = breaks;
  }
}

export class BundleUpdatedEvent extends Event {
  constructor() {
    super(Events.BUNDLE_UPDATED, { bubbles: true });
  }
}

export class SubscriptionUpdatedEvent extends Event {
  constructor(sellingPlan, variant, productId) {
    super(Events.SUBSCRIPTION_UPDATED, { bubbles: true });
    this.sellingPlan = sellingPlan;
    this.variant = variant;
    this.productId = productId;
  }
}

export class FiltersUpdatedEvent extends Event {
  constructor(url) {
    super(Events.FILTERS_UPDATED, { bubbles: true });
    this.url = url;
  }
}

export class FiltersFailedEvent extends Event {
  constructor() {
    super(Events.FILTERS_FAILED, { bubbles: true });
  }
}
